import type { OnyxTimeRange } from '@onyx/angular';

export const DAY_TIME_RANGE: OnyxTimeRange = {
  from: '00:00:00',
  to: '23:59:00',
} as const;
